import React, { useState } from 'react';
import { DeleteOutlined, EditOutlined } from '@mui/icons-material';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box, } from '@mui/material';
export const PatientGoalsTable = ({ items, onEdit, onDelete, isEditDisabled }) => {
    const [hoveredRow, setHoveredRow] = useState(null);
    const deleteItem = async (item) => {
        await axios.post('/api/carePlan/deletePatientGoal', {
            goalId: item.id,
        });
        onDelete?.(item.id);
    };
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, { style: { backgroundColor: '#EEEEEE', color: '#000000DE', fontFamily: 'Barlow', fontWeight: '500' } },
                    React.createElement(TableCell, null, "Goal"),
                    React.createElement(TableCell, null, "Metric"),
                    React.createElement(TableCell, null, "Baseline"),
                    React.createElement(TableCell, null, "Target"),
                    React.createElement(TableCell, null, "Prognosis"),
                    React.createElement(TableCell, null, "Notes"),
                    React.createElement(TableCell, null))),
            React.createElement(TableBody, null, items.map((goal, index) => (React.createElement(TableRow, { key: index, onMouseEnter: () => setHoveredRow(index), onMouseLeave: () => setHoveredRow(null), sx: {
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                } },
                React.createElement(TableCell, { style: { overflowWrap: 'anywhere' } }, goal.goal),
                React.createElement(TableCell, { style: { overflowWrap: 'anywhere' } }, goal.metric),
                React.createElement(TableCell, { style: { overflowWrap: 'anywhere' } }, goal.initial),
                React.createElement(TableCell, { style: { overflowWrap: 'anywhere' } }, goal.target),
                React.createElement(TableCell, { style: { overflowWrap: 'anywhere' } }, goal.prognosis),
                React.createElement(TableCell, { style: { overflowWrap: 'anywhere', whiteSpace: 'pre-wrap', } }, goal.goalDescription),
                React.createElement(TableCell, null,
                    React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                        React.createElement(Box, { sx: {
                                display: 'flex',
                                gap: 0.5,
                                opacity: hoveredRow === index ? 1 : 0,
                                transition: 'opacity 0.2s',
                            } },
                            React.createElement(IconButton, { style: { height: '20px', width: '20px', color: '#0000008A' }, size: "small", disabled: isEditDisabled, onClick: (e) => {
                                    e.stopPropagation();
                                    onEdit?.(goal.id);
                                } },
                                React.createElement(EditOutlined, { style: { height: '20px', width: '20px', color: '#0000008A' }, fontSize: "small" })),
                            React.createElement(IconButton, { size: "small", disabled: isEditDisabled, style: { height: '20px', width: '20px', color: '#D32F2F' }, onClick: (e) => {
                                    e.stopPropagation();
                                    deleteItem(goal);
                                } },
                                React.createElement(DeleteOutlined, { style: { height: '20px', width: '20px', color: '#D32F2F' }, fontSize: "small" }))))))))))));
};
